jQuery(document).ready(function($) {

	// Force toepassing submenu link
	$('body').on('click', '.submenu__cat-inner', function (e) {
		let href = $(this).attr('href');
		if (href) {
			window.location.href = href;
			window.location.reload();
		}
	});

	$('.header__search').on('click', function() {
		$('.header__search-container').addClass('header__search-container--show');
		setTimeout(function () {
			$('.header__search-container .search-field').focus();
		},200)
	})

	$('.header__search-close').on('click', function() {
		$('.header__search-container').removeClass('header__search-container--show');
		setTimeout(function () {
			$('.header__search-container .search-field').blur();
		},200)
	})

	if ($(window).width() > 1023) {
		// Main nav first child
		$('.header__bottom-left-nav li.menu-item-has-children:nth-child(1), .submenu__assortment .container').hover(function() {
			$('body').addClass('body--has-overlay');
		}, function() {
			$('body').removeClass('body--has-overlay');
		})

		// Main nav second child
		$('.header__bottom-left-nav li.menu-item-has-children:nth-child(2), .submenu__application .container').hover(function() {
			// $('.submenu__application').addClass('submenu__application--open');
			$('body').addClass('body--has-overlay');
		}, function() {
			$('body').removeClass('body--has-overlay');
		})

		// Main nav third child
		$('.header__bottom-left-nav li.menu-item-has-children:nth-child(3), .submenu__application .container').hover(function() {
			// $('.submenu__application').addClass('submenu__application--open');
			$('body').addClass('body--has-overlay');
		}, function() {
			$('body').removeClass('body--has-overlay');
		})

		// Main nav fourth child
		$('.header__bottom-left-nav li.menu-item-has-children:nth-child(4), .submenu__application .container').hover(function() {
			// $('.submenu__application').addClass('submenu__application--open');
			$('body').addClass('body--has-overlay');
		}, function() {
			$('body').removeClass('body--has-overlay');
		})

		// Main nav fifth child
		$('.header__bottom-left-nav li.menu-item-has-children:nth-child(5), .submenu__application .container').hover(function() {
			// $('.submenu__application').addClass('submenu__application--open');
			$('body').addClass('body--has-overlay');
		}, function() {
			$('body').removeClass('body--has-overlay');
		})

		$('.header__top-nav li.menu-item-has-children:nth-child(1), .submenu__application .container').hover(function() {
			$('body').addClass('body--has-overlay');
		}, function() {
			$('body').removeClass('body--has-overlay');
		})
		$('.header__top-nav li.menu-item-has-children:nth-child(2), .submenu__application .container').hover(function() {
			$('body').addClass('body--has-overlay');
		}, function() {
			$('body').removeClass('body--has-overlay');
		})
	}

	if ($(window).width() <= 1023) {

		// Main nav
		$('.header__bottom-left-nav li:nth-child(1) .header__mobile-nav-toggle').on('click', function() {
			$('.submenu__assortment').addClass('submenu__assortment--open');
			$('.submenu__mobile-close').addClass('submenu__mobile-close--visible');
		});
		$('.header__bottom-left-nav li:nth-child(2) .header__mobile-nav-toggle').on('click', function() {
			$('.submenu__application').addClass('submenu__application--open');
			$('.submenu__mobile-close').addClass('submenu__mobile-close--visible');
		});

		// Sub nav
		$('.submenu__mobile-nav-toggle').on('click', function(e) {
			e.preventDefault();
			let cur_tab = $(this).data('tab');
			$('[data-content-tab="' + cur_tab + '"]').addClass('submenu__tab-content--active');
			$('.submenu__mobile-close-content').addClass('submenu__mobile-close-content--visible');
		});

		// Sub nav close
		$('.submenu__mobile-close').on('click', function() {
			$('.submenu__mobile-close').removeClass('submenu__mobile-close--visible');
			$('.submenu__application').removeClass('submenu__application--open');
			$('.submenu__assortment').removeClass('submenu__assortment--open');
		});

		$('.submenu__mobile-close-content').on('click', function() {
			$('.submenu__mobile-close-content').removeClass('submenu__mobile-close-content--visible');
			$('.submenu__tab-content').removeClass('submenu__tab-content--active');

		});

		$('.header__mobile-toggle').on('click', function() {
			$('.header').toggleClass('header--nav-open');
			$('.header__mobile-toggle-inner').toggleClass('header__mobile-toggle-inner--open');
			$('.header__inner').toggleClass('header__inner--open');

			if ($('.submenu__mobile-close--visible').length > 0) {
				$('.submenu__mobile-close').removeClass('submenu__mobile-close--visible');
			}

			if ($('.submenu__application--open').length > 0) {
				$('.submenu__application').removeClass('submenu__application--open');
			}

			if ($('.submenu__assortment--open').length > 0) {
				$('.submenu__assortment').removeClass('submenu__assortment--open');
			}

			if ($('.submenu__tab-content--active')) {
				$('.submenu__tab-content').removeClass('submenu__tab-content--active');
			}

			if ($('.submenu__mobile-close-content--visible').length > 0) {
				$('.submenu__mobile-close-content').removeClass('submenu__mobile-close-content--visible');
			}
		})

		// Replace search container
		let searchContainer = $('.header__search-container');
		searchContainer.remove();
		$('.header').append(searchContainer);

		$('.header__search-close').on('click', function() {
			$('.header__search-container').removeClass('header__search-container--show');
		});
        $('.header__mobile-nav-toggle').on('click', function() {
            $(this).parent().toggleClass('menu-item-has-children--open');
        	$(this).next('.sub-menu').toggleClass('sub-menu--open');
        });
	}
});
